/**
 * @generated SignedSource<<826f513cc512b3d715b34a9b092d1da7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetailsShipping_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailReturnPolicy_item" | "PdpSharedDetailShipping_item">;
  readonly " $fragmentType": "PdpRespSidebarDetailsShipping_item";
};
export type PdpRespSidebarDetailsShipping_item$key = {
  readonly " $data"?: PdpRespSidebarDetailsShipping_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsShipping_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetailsShipping_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailReturnPolicy_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "51a10919f66b85ed3588405de3be2933";

export default node;
